import { render, staticRenderFns } from "./DataMap.vue?vue&type=template&id=2b3155eb"
import script from "./DataMap.vue?vue&type=script&lang=js"
export * from "./DataMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports